import c from "./seilasArticleBottomAdvert.module.scss"
import knsLogo from "./images/kns-logo.png"

export default function SeilasArticleBottomAdvert() {
	return (
		<div className={c.root}>
			<hr/>
			<div className={c.container}>
				<img src={knsLogo} className={c.knsLogo}/>
				<div className={c.txtContainer}>
					<p>Denne saken er hentet fra <b>KNS sitt eget medlemsmagasin, SEILAS.</b> Du får tilsendt fire eksklusive utgaver pr. år som medlem. Som KNS-medlem blir du med i et stort seilfelleskap og får flere fordeler.</p>
					<a target={"_blank"} href="https://vbmedia.no/seilas-les-mer-kns">Les mer her</a>
				</div>
			</div>
		</div>
	)
}